export const YEAR_RECAP_FLAG = 'AHA-48191-release-recap-2026'

export const YEAR_RECAP_ROUTE_NAME = 'YearRecap'
export const YEAR_RECAP_ROUTE_PATH = '/recap/:year(\\d{4})'
export const YEAR_RECAP_PUBLIC_ROUTE_NAME = 'YearRecapPublic'
export const YEAR_RECAP_PUBLIC_ROUTE_PATH = '/recap/shared/:token'

export const YEAR_RECAP_EVENTS = {
  VIEW: 'Recap > View',
  SHARE_CLICK: 'Recap > Share Click',
  CREATE_PUBLIC_LINK: 'Recap > Create Public Link',
  REVOKE_PUBLIC_LINK: 'Recap > Revoke Public Link',
  SLIDE_VIEWED: 'Recap > Slide Viewed',
  SUMMARY_REACHED: 'Recap > Summary Reached',
  STORY_COMPLETED: 'Recap > Story Completed',
  SHARE_INTENT: 'Recap > Share Intent',
  SHARE_COPY_GENERATED: 'Recap > Share Copy Generated',
  DOWNLOAD_VISUAL: 'Recap > Download Visual',
  SHARE_OPENED: 'Recap > Share Opened',
  SUMMARY_CTA_CLICK: 'Recap > Summary CTA Click',
}

export const CHARACTER_KEYS = [
  'heart_stealer', 'plot_twister', 'energy_booster', 'showstopper', 'creative_chameleon', 'quiz_wizard', 'spark_starter',
]

// recap-music.mp3 is 128 BPM and plays once from the start of the song; its first downbeat is just after 0 s.
export const MUSIC_BEAT_SECONDS = 60 / 128
export const MUSIC_FIRST_DOWNBEAT_SECONDS = 0.024

export const SLIDE_BEATS = 12
export const SLIDE_DURATION_MS = SLIDE_BEATS * MUSIC_BEAT_SECONDS * 1000

export const YEAR_RECAP_PUBLIC_DEFAULT_SOURCE = 'recap_public'
export const YEAR_RECAP_SIGNUP_REF = 'year_recap_share'
export const FIRST_RECAP_SHARE_SOURCE_PROP = 'first_recap_share_source'
